import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableRow, Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const marketNamesArray = this.props.marketNamesArray;
    const EnhancedTableHead = this.props.EnhancedTableHead;
    const classes = this.props.classes;
    const order = this.props.order;
    const orderBy = this.props.orderBy;
    const handleRequestSort = this.props.handleRequestSort;

    return (
      <div style={{ padding: '10px' }}>
        <h3><center><u>Price Approval Report</u></center></h3>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer >
            <Table aria-label="table variants" >
              <EnhancedTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={productData.length}
                sx={{ border: '1px solid black' }}
              />
              <TableBody>
                {productData.map((market, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row" align="center" sx={{ border: '1px solid black' }}>
                        {market.sku}
                      </TableCell>
                      <TableCell component="th" scope="row" align="center" sx={{ border: '1px solid black' }}>
                        {market.buyingPrice > 0 ? parseFloat(market.buyingPrice).toFixed(2) : '-'}
                      </TableCell>
                      <TableCell component="th" scope="row" align='center' sx={{ border: '1px solid black' }}>
                        {market.sellingPrice > 0 ? parseFloat(market.sellingPrice).toFixed(2) : '-'}
                      </TableCell>
                      <TableCell component="th" scope="row" align='right'sx={{ border: '1px solid black' }}>
                        {market.proposedPrice > 0 ? parseFloat(market.proposedPrice).toFixed(2) : '-'}
                      </TableCell>
                      <TableCell component="th" scope="row" align='right'sx={{ border: '1px solid black' }}>
                        {market.competitorPrice > 0 ? parseFloat(market.competitorPrice).toFixed(2) : '-'}
                      </TableCell>
                      {marketNamesArray.map((column) => {
                        const value = market[column.market];
                        return (
                          <TableCell align={column.tableCellAlign == 1 ? 'center' : column.tableCellAlign == 2 ? 'left' : 'right'} style={{ paddingRight: '30px' }} sx={{ border: '1px solid black' }}>
                            {value == undefined ? '-' : column.numeric == true ? parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2)}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
                <TableRow>
                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                        Total
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                    {productData.reduce((acc, curr) => acc + (curr.buyingPrice || 0), 0).toFixed(2)}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                        {productData.reduce((acc, curr) => acc + (curr.sellingPrice || 0), 0).toFixed(2)}
                    </TableCell>
                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                        {productData.reduce((acc, curr) => acc + (curr.proposedPrice || 0), 0).toFixed(2)}
                    </TableCell>
                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: 'bold', border: '1px solid black' }}>
                        {productData.reduce((acc, curr) => acc + (curr.competitorPrice || 0), 0).toFixed(2)}
                    </TableCell>
                    {marketNamesArray.map((column, colIndex) => (
                        <TableCell key={colIndex} scope="row" align={column.tableCellAlign == 1 ? 'center' : column.tableCellAlign == 2 ? 'left' : 'right'} style={{ paddingRight: '30px', fontWeight: 'bold', border: '1px solid black' }}>
                            {productData.reduce((acc, curr) => acc + (curr[column.market] || 0), 0).toFixed(2)}
                        </TableCell>
                    ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
